import { ContentType } from '@entries/content-types'
import ContentfulContentArticlePictoRight from '@entries/contentful-content-article-refresh-picto-right'
import ContentfulContentArticlePictoRightLeft from '@entries/contentful-content-article-refresh-picto-right-left'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { ErrorMappingMsg } from '@ui/error-boundary'
import { graphql } from 'gatsby'
import React from 'react'
import { useErrorBoundary } from 'react-error-boundary'

const ContentfulPageSectionPictoRight: Utils.EntryFC<
  Queries.ContentfulPageSectionPictoRightFragment
> = ({
  content: { contents = [] },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  if (contents.length > 4) {
    const { showBoundary } = useErrorBoundary()
    showBoundary({
      code: ErrorMappingMsg.ErrorContentfulContentArticlesLengthBetween3And4,
    })
  }

  return (
    <div
      className="flex flex-col tablet:flex-row tablet:gap-12 laptop:gap-32"
      {...entryInspectorProps()}
    >
      <Entry
        content={contents[0]}
        mapping={{
          [ContentType.ContentfulContentArticle]:
            ContentfulContentArticlePictoRightLeft,
        }}
      />
      <div
        className="flex w-full flex-col justify-center"
        {...fieldInspectorProps({
          fieldId: 'contents',
        })}
      >
        {contents.slice(1).map((item: any, i: number) => (
          <div
            key={i}
            className="border-solid border-[#DDDDDD] [&:not(:last-child)]:border-b"
          >
            <Entry
              content={item}
              mapping={{
                [ContentType.ContentfulContentArticle]:
                  ContentfulContentArticlePictoRight,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export const query = graphql`
  fragment ContentfulPageSectionPictoRight on ContentfulSection {
    ...ContentfulEntry
    contents {
      ...ContentfulContentArticleRefreshPictoRightLeft
      ...ContentfulContentArticleRefreshPictoRight
    }
  }
`

export default withDisplayName(
  ContentfulPageSectionPictoRight,
  'ContentfulPageSectionPictoRight'
)
